import { Outlet } from 'react-router-dom';
import QuizAuthGuard from './QuizAuthGuard';

const QuizLayout = () => {
  return (
    <QuizAuthGuard text="Prijavi se kako bi učestvovao u kvizu">
      <Outlet />
    </QuizAuthGuard>
  );
};

export default QuizLayout;
